import {isLoggedIn, getAccessToken} from './auth';
import axios from 'axios';

const BASE_URL = process.env.VUE_APP_OBWAN_SERVICES_URL;

function options () {
  return { headers: { Authorization: `Bearer ${getAccessToken()}` } }
}

async function getProductionUnits () {
  if (isLoggedIn()) {
    let { data } = await axios.get(`${BASE_URL}/production-units`, options());
    return data;
  } else {
    throw new Error('User not authenticated.')
  }
}

async function getProductionUnit (id) {
  if (isLoggedIn()) {
    let { data } = await axios.get(`${BASE_URL}/production-unit/${id}`, options());
    return data;
  } else {
    throw new Error('User not authenticated.')
  }
}

async function startProductionUnit (id) {
  if (isLoggedIn()) {
    let { data } = await axios.put(`${BASE_URL}/production-unit/${id}/start`, {}, options());
    return data;
  } else {
    throw new Error('User not authenticated.')
  }
}

async function stopProductionUnit (id) {
  if (isLoggedIn()) {
    let { data } = await axios.put(`${BASE_URL}/production-unit/${id}/stop`, {}, options());
    return data;
  } else {
    throw new Error('User not authenticated.')
  }
}

export default {
  getProductionUnits, getProductionUnit, startProductionUnit, stopProductionUnit
}